module.exports = "<div class=\"card\">\n  <h4 class=\"card-heading\">Collision Types</h4>\n  <div id=\"incidentdiv\"></div>\n</div>\n"